import React from "react";
import { HomeIcon, AwayIcon, NeutralIcon } from "./VenueIcons";

export type FormPoint = { state: number; venue?: "H" | "A" | "N" };

type TeamFormProps = { form: FormPoint[] };

const TeamForm: React.FC<TeamFormProps> = ({ form }) => {
  if (!form || form.length === 0) return null;

  return (
    <div className="grid auto-cols-max grid-flow-col gap-2">
      {form.map((fp, i) => (
        <div key={i} className="grid place-items-center gap-1">
          <div
            className={`h-[1.5vw] w-[1.5vw] rounded-full ${
              fp.state === -1
                ? `bg-red`
                : fp.state === 0
                ? `bg-yellow`
                : `bg-green`
            }`}
            title={fp.state === 1 ? "Win" : fp.state === -1 ? "Loss" : "Draw"}
          />
          {fp.venue && (
            <div className="text-white/80">
              {fp.venue === "H" ? (
                <HomeIcon />
              ) : fp.venue === "A" ? (
                <AwayIcon />
              ) : (
                <NeutralIcon />
              )}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default TeamForm;
